export const ORGANIZATION = {
    COLLECTION: {
        url: '/organizations/:organizationId/clients',
        queryKey: 'getOrganizations'
    },
    DETAILS: {
        url: '/organizations/:organizationId',
        queryKey: 'getOrganization'
    },
    UPDATE_SUBDOMAIN: {
        url: '/organizations/:organizationId/subdomain'
    },
    COMPANY_INFO: {
        url: '/companyInfos/:registrationNumber',
        queryKey: 'checkRegistrationNumber'
    },
    ALERTS: {
        url: '/organizations/:organizationId/alertReceivers',
        queryKey: 'getAlertReceivers'
    },
    SIM_OFFERS: {
        url: '/sims/offersForOrganization',
        queryKey: 'getOrganizationSimOffers'
    },
    UPDATE_SIM_OFFERS: {
        url: '/sims/offersForOrganization'
    },
    UPDATE_TYPE_ORGANIZATION: {
        url: '/organizations/:uuid/toWhiteLabel'
    },
    ENVELOPES_COLLECTION: {
        url: '/organizations/:organizationId/clientsEnvelopes'
    },
    EXPORT: {
        url: '/organizations/export'
    },
    PORT: {
        url: '/organizations/:uuid/connectionPoints'
    },
    SUB_DOMAIN: {
        url: '/organizations/:uuid/subDomain'
    },
    SIM_ALERTS: {
        url: '/organizations/:uuid/simAlerts',
        queryKey: 'getSimAlerts'
    },
    SIM_ALERTS_RECEIVERS: {
        url: '/organizations/:uuid/simAlertReceivers'
    }
};